import * as constants from './constants';      
export const MSConstant = constants; 
